import { InternationalStreetValidationMagentoResponse, InternationalStreetValidationResponse, USStreetValidationMagentoResponse, USStreetValidationResponse } from "../interfaces/address-validation.interface";

export function mapAddressUSValidationMagento(streetValidation: USStreetValidationMagentoResponse): USStreetValidationResponse {
    const content = streetValidation.content;
    return {
        street1: content.street1,
        street2: content.street2,
        city: content.city,
        state: content.state,
        zipCode: content.zip_code,
        plus4Code: content.plus4_code,
        county: content.county,
        rdiType: content.rdi_type,
        dpvMatchCode: content.dpv_match_code,
        country: content.country,
    }
}

// Will return undefined because magento is returning the content as an array when there's no data
export function mapAddressInternationalValidationMagento(streetValidation: InternationalStreetValidationMagentoResponse): InternationalStreetValidationResponse | undefined {
    if (Object.keys(streetValidation.content).length == 0) {
        return;
    }

    const content = streetValidation.content;
    return {
        street1: content.street1,
        street2: content.street2,
        organization: content.organization,
        city: content.city,
        state: content.state,
        zipCode: content.zip_code,
        country: content.country,
        verificationStatus: content.verification_status,
        addressPrecision: content.address_precision,
        maxAddressPrecision: content.max_address_precision,
    }
}